import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-card',
  templateUrl: './logo-card.component.html',
  styleUrls: ['./logo-card.component.scss']
})
export class LogoCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
